
import TradeInWizard from "./components/wizard";
import style from "./styles.module.scss";

const TradeIn = () => {
  return (
    <section className={style.tradeInWizard}>
      <div className={style.tradeInWizard__container}>
        <TradeInWizard />
      </div>
    </section>
  );
};

export default TradeIn;
